/* -----------------------------------------------------------
General notification banners
----------------------------------------------------------- */

DomObserver.observe('.js-page-notification', notifications => {
  notifications.forEach(notification => {
    // Find the notification ID and close button
    const ID = notification.getAttribute('data-notification-id');
    const close = notification.querySelector('.js-page-notification__close');
    // Find any links in the notification
    const links = [...notification.querySelectorAll('a, .button')];

    // An intersection observer to fix the notification banner to the window
    const Observer = new IntersectionObserver(entries => {
      notification.classList.toggle('fixed', !entries[0].isIntersecting);
    });

    // If the notification has a next sibling, observe it for intersection changes
    if (notification.nextElementSibling) Observer.observe(notification.nextElementSibling);

    // Hide / Show the page notification
    [close, ...links].forEach(item => {
      item.addEventListener('click', () => {
        // Add a session storage item to prevent the notification from showing again
        sessionStorage.setItem(ID, 'true');

        // Hide the notification
        notification.classList.remove('visible');
      });
    });

    // If there is no session storage item, show the notification
    if (!sessionStorage.getItem(ID)) {
      notification.classList.add('visible');
    }
  });
});

/* -----------------------------------------------------------
Notification Takeover
----------------------------------------------------------- */

DomObserver.observe('.js-notification-modal', notifications => {
  Promise.all([import('@meteora-digital/modal')]).then(_ref => {
    let [moduleModal] = _ref;
    notifications.forEach(template => {
      // Get the notification ID
      const ID = template.getAttribute('data-notification-id');
      if (!sessionStorage.getItem(ID)) {
        const NotificationModal = new moduleModal.default();
        const notification = template.content.cloneNode(true);
        // Find any links in the notification
        const links = [...notification.querySelectorAll('a, .button')];

        // Append the notification to the modal
        NotificationModal.append(notification);
        // Open the modal
        NotificationModal.open();

        // When the modal is closed, set a session storage item to prevent it from showing again
        NotificationModal.on('close', () => {
          sessionStorage.setItem(ID, 'true');
        });
        links.forEach(link => {
          link.addEventListener('click', e => {
            NotificationModal.close();
          });
        });
      }
    });
  }).catch(error => {
    console.error('An error occurred while loading the modules:', error);
  });
});